/** Avvio, configurazione e migrazioni: li legge chi installa e gestisce Portman. */
export const avvio = {
  "avvio.serveChiave":
    "Serve una master key? Generala con:\n" +
    "  bun run keygen\n" +
    "e impostala in PORTMAN_MASTER_KEY (conservala: senza di essa i segreti salvati sono irrecuperabili).",
  "avvio.permessiLarghi": (p: { cosa: string }) => `${p.cosa} è leggibile da altri utenti della macchina`,
  "avvio.fileChiave": "il file della master key",
  "avvio.fileEnv": "il file .env, che contiene la master key,",
  "avvio.migrazioniApplicate": "migrazioni applicate",
  "avvio.operazioniInterrotte": "operazioni interrotte da un riavvio precedente",
  "avvio.puliziaCredenziali": "pulizia credenziali orfane fallita",
  "avvio.inAscolto": "Portman è in ascolto",
  "avvio.primoAvvio":
    "nessun utente configurato: apri Portman nel browser per creare il primo amministratore, " +
    "con questo token di primo avvio",
  "avvio.sessioniScadute": "sessioni scadute rimosse",
  "avvio.arresto": "arresto in corso",
  "avvio.guasto": "operazione terminata con un guasto",
  "avvio.richiestaFallita": "richiesta fallita",
  "avvio.interrottaDaRiavvio": "operazione interrotta dal riavvio di Portman",

  "config.nonValida": (p: { problemi: string }) => `Configurazione non valida:\n${p.problemi}`,
  "config.campoGenerico": "configurazione",
  "config.chiaveObbligatoria": "è obbligatoria",
  "config.chiaveBase64": "deve essere in formato base64",
  "config.chiaveByte": (p: { byte: number }) => `deve decodificare a esattamente ${p.byte} byte`,
  "config.tokenCorto": "deve avere almeno 16 caratteri",
  "config.npmIncompleto":
    "per usare Nginx Proxy Manager servono tutte e tre le variabili: " +
    "PORTMAN_NPM_URL, PORTMAN_NPM_IDENTITY e PORTMAN_NPM_SECRET",
  "config.poolInvertito": "il pool porte non può iniziare dopo la sua fine",
  "config.dueForme": (p: { variabile: string; file: string }) =>
    `${p.variabile}: fornita sia direttamente sia tramite ${p.file}, scegline una`,
  "config.fileIlleggibile": (p: { variabile: string; percorso: string }) =>
    `${p.variabile}: non riesco a leggere "${p.percorso}"`,

  "migrazioni.duplicata": (p: { versione: number }) => `esistono due migrazioni con versione ${p.versione}`,
  "migrazioni.cambiata": (p: { migrazione: string }) =>
    `la migrazione ${p.migrazione} è già stata applicata ma il suo contenuto è cambiato. ` +
    "Le migrazioni applicate sono immutabili: aggiungine una nuova invece di modificarla.",
  "migrazioni.fallita": (p: { migrazione: string; dettaglio: string }) =>
    `la migrazione ${p.migrazione} è fallita: ${p.dettaglio}`,
  "migrazioni.nomeNonValido": (p: { file: string }) =>
    `nome di migrazione non valido: ${p.file} (atteso il formato NNN_nome.sql)`,
};
